// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { IdMap } from '@/legacy/types/api/store'
import { MapEntityPhoneNumber } from '@/legacy/types/entities/phoneNumbers'
import { idMapTransform } from '@/libs/format/objects'

export const useMapEntityPhoneNumberApi = apiStore<
  MapEntityPhoneNumber,
  IdMap<MapEntityPhoneNumber>
>('mapEntityPhoneNumberApi', '/api/phone_numbers/entity_maps', {
  transformData: (d: { data: MapEntityPhoneNumber[] }) =>
    idMapTransform({}, 'data', 'mapEntityPhoneNumberId', d.data),
})
export const useMapEntityOtherContactPhoneNumberApi = apiStore<
  MapEntityPhoneNumber,
  IdMap<MapEntityPhoneNumber>
>('mapEntityOtherContactPhoneNumberApi', '/api/phone_numbers/entity_maps', {
  transformData: (d: { data: MapEntityPhoneNumber[] }) =>
    idMapTransform({}, 'data', 'mapEntityPhoneNumberId', d.data),
})
